export default "__VITE_ASSET__C7QN_GRL__"